(function () {
  'use strict';

  const TOGGLE_ID  = 'mannequin-display-toggle';
  const VIEW_PARAM = 'view';
  const FLAT_VALUE = 'flat';

  function isFlat() {
    return new URL(window.location.href).searchParams.get(VIEW_PARAM) === FLAT_VALUE;
  }

  /* Keep ?view=flat across filter/sort form submissions */
  function injectViewParamIntoForms() {
    if (!isFlat()) return;

    ['FacetFiltersForm', 'FacetFiltersFormMobile', 'FacetSortDrawerForm'].forEach(id => {
      const form = document.getElementById(id);
      if (!form || form.querySelector('input[name="view"]')) return;
      const input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = VIEW_PARAM;
      input.value = FLAT_VALUE;
      form.appendChild(input);
    });
  }

  injectViewParamIntoForms();
  const formObserver = new MutationObserver(injectViewParamIntoForms);
  formObserver.observe(document.body, { childList: true, subtree: true });

  function apply(flat) {
    const url = new URL(window.location.href);
    if (flat) {
      url.searchParams.set(VIEW_PARAM, FLAT_VALUE);
    } else {
      url.searchParams.delete(VIEW_PARAM);
    }
    window.location.href = url.toString();
  }

  function initToggle() {
    const toggle = document.getElementById(TOGGLE_ID);
    if (!toggle) return false;
    if (toggle.dataset.initialized === 'true') return true;
    toggle.dataset.initialized = 'true';

    toggle.checked = isFlat();

    const label = document.querySelector('label[for="' + TOGGLE_ID + '"]');
    const hasTouchscreen = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    /* touchUsed flag: true only when actual finger touch triggered navigation.
       Blocks the iOS ghost-click that follows touchend, but lets real mouse
       clicks on hybrid (touch + mouse) devices fall through to change event. */
    let touchUsed = false;

    toggle.addEventListener('change', function () {
      if (!touchUsed) apply(toggle.checked);
    });

    if (label && hasTouchscreen) {
      label.addEventListener('touchend', function (e) {
        touchUsed = true;
        e.preventDefault();
        e.stopPropagation();
        apply(!toggle.checked);
      });
      /* Block only the ghost-click that immediately follows touchend */
      label.addEventListener('click', function (e) {
        if (touchUsed) {
          e.preventDefault();
          e.stopPropagation();
          touchUsed = false;
        }
      });
    }

    return true;
  }

  initToggle();

  const obs = new MutationObserver(function () {
    if (initToggle()) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 10000);

  /* Close stale open disclosures — fixes iOS bfcache & ghost-click backdrop */
  function closeStaleDisclosures() {
    document.querySelectorAll('.disclosure-has-popup[open]').forEach(function (el) {
      el.removeAttribute('open');
      el.classList.remove('menu-opening');
    });
    /* Also close hamburger nav if it was left open (bfcache restore) */
    var hamburger = document.getElementById('Details-menu-drawer-container');
    if (hamburger && hamburger.hasAttribute('open')) {
      hamburger.removeAttribute('open');
      hamburger.classList.remove('menu-opening');
    }
    document.body.classList.remove('filter-show', 'o-h-xs', 'o-h-sm', 'menu-mobile-show', 'o-h-md');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', closeStaleDisclosures);
  } else {
    closeStaleDisclosures();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) closeStaleDisclosures();
  });

  /* Tooltip — mobile tap */
  function initTooltip() {
    document.querySelectorAll('.mannequin-tooltip-btn').forEach(function (btn) {
      if (btn.dataset.tooltipInit) return;
      btn.dataset.tooltipInit = 'true';

      const box = btn.nextElementSibling;
      if (!box) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        box.classList.toggle('active');
      });
    });

    document.addEventListener('click', function () {
      document.querySelectorAll('.mannequin-tooltip__box.active').forEach(el => {
        el.classList.remove('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltip);
  } else {
    initTooltip();
  }
})();
